import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ImageWithFallback2 from 'components/desktop/_general/Image/ImageWithFallback2';
import * as Image from 'types/Media/Image';

interface IProps {
	image: Image.Type | null;
}

const Picture = (props: IProps) => {
	if (props.image) {
		return (
			<div className="card-picture">
				<ImageWithFallback2
					alt="thumbnail"
					src={props.image.url}
					placeholderStyle={{
						height: '230px',
						minWidth: '230px',
						backgroundColor: 'grey',
					}}
				/>
			</div>
		);
	}
	return (
		<div className="card-picture-placeholder d-flex justify-content-center align-items-center">
			<FontAwesomeIcon size="3x" icon={faCamera} />
		</div>
	);
};

export default Picture;
